import React from 'react'
import { Box, Fade, Stack } from '@mui/material'
import { useQuery } from '@apollo/client'

import { useNavigate } from 'router'

import { TOPOLOGY_BY_SITE } from '../../Topology/operations-gql/queries'
import DetailHeader from './components/DetailHeader'
import DetailsWidget from './components/Overview'
import TopologyPreview from './components/TopologyPreview'
import AccessPointSections from './sections/AccessPointSections'
import { CctvCameraSections, CctvServerSections } from './sections/CctvSections'
import FirewallSections from './sections/FirewallSections'
import InverterSections from './sections/InverterSections'
import SwitchSections from './sections/SwitchSections'

const DETAIL_SECTIONS = {
  access_points: AccessPointSections,
  switches: SwitchSections,
  cctv_cameras: CctvCameraSections,
  cctv_servers: CctvServerSections,
  firewalls: FirewallSections,
  inverters: InverterSections
}

const CompleteDetailView = ({ equipment, equipments, hardwareType, basePath, buildSearch }) => {
  const navigate = useNavigate()
  const selectedIndex = equipments.findIndex(item => item.uuid === equipment.uuid)
  const previous = selectedIndex > 0 ? equipments[selectedIndex - 1] : null
  const next = selectedIndex >= 0 && selectedIndex < equipments.length - 1 ? equipments[selectedIndex + 1] : null
  const DetailSections = DETAIL_SECTIONS[hardwareType]
  const { data: topologyData, loading: topologyLoading } = useQuery(TOPOLOGY_BY_SITE, {
    variables: { sf_id: equipment?.site?.sf_id },
    skip: !equipment?.site?.sf_id
  })
  const topology = topologyData?.topology

  const navigateToEquipment = (item) => {
    if (!item) return
    navigate({
      pathname: `${basePath}/${item.uuid}`,
      search: buildSearch({ view: 'complete' })
    })
  }

  const navigateBack = () => {
    navigate({
      pathname: basePath,
      search: buildSearch({ view: 'complete' })
    })
  }

  return (
    <Fade in timeout={220} key={equipment.uuid}>
      <Stack
        gap={2}
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          maxWidth: '100%',
          pr: 0.5,
          pb: 2,
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        <DetailHeader
          equipment={equipment}
          hardwareType={hardwareType}
          onBack={navigateBack}
          onPrevious={() => navigateToEquipment(previous)}
          onNext={() => navigateToEquipment(next)}
          hasPrevious={Boolean(previous)}
          hasNext={Boolean(next)}
        />

        <Stack direction={{ xs: 'column', lg: 'row' }} gap={2}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <DetailsWidget equipment={equipment} topology={topology} topologyLoading={topologyLoading} />
          </Box>
          <TopologyPreview equipment={equipment} topology={topology} loading={topologyLoading} />
        </Stack>

        {DetailSections && <DetailSections equipment={equipment} />}
      </Stack>
    </Fade>
  )
}

export default CompleteDetailView
